// eslint-disable-next-line jira/filename-case
import React from 'react';
import {
	issueTypeAvatarSizesMap,
	makeAvatarUrlFromId,
	type IssueTypeAvatarSizes,
} from './makeAvatarUrlFromId.tsx';

type PropsOld = {
	avatarId: string;
	size: IssueTypeAvatarSizes;
	name?: string;
};

export const IssueTypeAvatarOld = ({ avatarId, size, name = '' }: PropsOld): React.JSX.Element => {
	const sizeInPx = issueTypeAvatarSizesMap[size];
	const avatarUrl = makeAvatarUrlFromId(avatarId, size);

	return <img src={avatarUrl} alt={name} width={sizeInPx} height={sizeInPx} />;
};

type Props = {
	avatarUrl: string;
	size: IssueTypeAvatarSizes;
	name?: string;
};

export const IssueTypeAvatar = ({ avatarUrl, size, name = '' }: Props): React.JSX.Element => {
	const sizeInPx = issueTypeAvatarSizesMap[size];

	return <img src={avatarUrl} alt={name} width={sizeInPx} height={sizeInPx} />;
};
